import { useLayoutEffect, useState } from 'react'

import { useLead, useProposal } from '@itau-loans-www/hooks'
import { http } from '@itau-loans-www/services'
import auth from '@itau-loans-www/services/http/auth'
import { goTo } from '@itau-loans-www/utils'

const usePersonalData = () => {
  const { setIsLoading, product } = useProposal()
  const isFGTS = product?.proposal?.productCode === 'FGTS'

  const { changeLeadData } = useLead()

  const [maritalOptions, setMaritalOptions] = useState()
  const [hasBirthInput, setHasBirthInput] = useState(true)
  const [occupationsOptions, setOccupationsOptions] = useState()
  const [statesOptions, setStatesOptions] = useState()

  useLayoutEffect(() => {
    auth({}).then(async () => {
      http.formalization.getPersonalData().then((data) => {
        setHasBirthInput(data?.show_date_of_birth_input)
      })

      http.formalization.getMaritalStatuses().then((data) => {
        const options = data.map((item) => {
          const label = item['marital_statuses_name'].toLowerCase()

          return {
            label: label[0].toUpperCase() + label.substring(1),
            value: item['marital_statuses_id']
          }
        })
        setMaritalOptions(options)
      })

      if (isFGTS) {
        http.formalization.getOccupations().then((data) => {
          const options = data.map((item) => {
            const label = item['occupation_name'].toLowerCase()

            return {
              label: label[0].toUpperCase() + label.substring(1),
              value: item['occupation_id']
            }
          })

          setOccupationsOptions(options)
        })
      }

      http.formalization.getStates().then((data) => {
        const options = data.map((item) => {
          return {
            label: item['state_name'],
            value: item['state_id']
          }
        })

        setStatesOptions(options)
      })
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onSubmit = (value) => {
    const requestBody = {
      ...value,
      occupation_id: isFGTS ? value['occupation_id'] : 0
    }

    changeLeadData({
      personal_data: {
        ...requestBody
      }
    })

    setIsLoading(true)

    http.formalization
      .putPersonalData(requestBody)
      .then(({ next_step }) => {
        goTo(next_step)
      })
      .catch((error) => {
        console.log({ error })
        setIsLoading(false)
      })
  }

  return {
    maritalOptions,
    occupationsOptions,
    statesOptions,
    onSubmit,
    isFGTS,
    hasBirthInput
  }
}

export default usePersonalData
